module.exports = __webpack_public_path__ + "img/material_selection@2x.6ad2bdb.jpg";